/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_SERVICEDESK_PORTAL_GROUPS = 'SERVICEDESK_PORTAL_GROUPS';
